/**
 * getHongKongDateTime
 * @param hoursToAdd
 * @returns {string} - Formatted date string in the format YYYY-MM-DD HH:mm:ss, 1 hour after the current HK time.
 */
export const getHongKongDateTime = (hoursToAdd: number = 1): string => {
  // Get current HK date
  const hkDate = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Hong_Kong" })
  );

  // Add hours - default is 1 hour
  hkDate.setHours(hkDate.getHours() + hoursToAdd);

  // Format the date
  const year = hkDate.getFullYear();
  const month = String(hkDate.getMonth() + 1).padStart(2, "0");
  const day = String(hkDate.getDate()).padStart(2, "0");
  const hours = String(hkDate.getHours()).padStart(2, "0");
  const minutes = String(hkDate.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:00`;
}